import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"

export const authOtpViaSMSApi = createAsyncThunk(
    'auth/auth-otp-via-sms',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.post(`/api/v1/login/send_otp/`, {
                user_type: "Dealor",
                type: "mobile"
            }
            )
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const authOtpViaSMSSlice = createSlice({
    name: 'auth-otp-via-sms',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(authOtpViaSMSApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(authOtpViaSMSApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(authOtpViaSMSApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const authOtpViaSMSReducer = authOtpViaSMSSlice.reducer